export default __webpack_public_path__ + "static/media/cash-register.c139b40d.png";